export default {"src":"/_next/static/media/RenewalArrowUpRight.0c1de7dc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};